import { ImageStyle, StyleProp, TextStyle, ViewStyle } from 'react-native';

type NamedStyles = StyleProp<ViewStyle | TextStyle | ImageStyle>;
type StylesTuple<T = NamedStyles> = [T, boolean];

const getStyles = <T = NamedStyles>(styles: StylesTuple<T>[]): T[] =>
  styles.reduce((appliedStyles: T[], [style, applyStyle]) => {
    if (applyStyle) {
      return [...appliedStyles, style];
    }

    return appliedStyles;
  }, []);

export { getStyles };
export type { StylesTuple };
